import React, { useCallback, useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Pivot, PivotItem } from '@fluentui/react';
import { Tab, TabList } from '@fluentui/react-components';
import { AdPreviewSurface } from './shared';

export const PerfMaxAdPreviewControls = (props) => {
  const {
    onSurfaceChange,
    onPlacementFilterChange,
    permissions,
    showAdPreviewControlsV2 = false,
  } = props;

  const [surfaceChoice, setSurfaceChoice] = useState('Msn');

  const surfaceMap = useMemo(() => {
    if (showAdPreviewControlsV2) {
      return ({
        [AdPreviewSurface.Msn]: ['msan_191x100', 'msan_1x1', 'mma_4x1', 'mma_1x2', 'mma_169x100', 'mma_124x100', 'mma_153x100', 'edge_201x100'],
        [AdPreviewSurface.Bing]: ['mma_191x100', 'bing_text'],
        [AdPreviewSurface.Outlook]: ['outlook_text_mobile', 'outlook_text_web'],
      });
    }
    return ({
      Bing: ['mma_191x100', 'bing_text'],
      Msn: ['msan_191x100', 'msan_1x1', 'edge_178x100', 'msan_150x100', 'msan_133x100', 'mma_4x1', 'mma_1x2'],
      Edge: ['mma_191x100', 'edge_178x100'],
      Outlook: ['outlook_text_mobile', 'outlook_text_web'],
    });
  }, [showAdPreviewControlsV2]);

  const placementFilterByPreviewControlState = useCallback((placemenet) => {
    const { key } = placemenet;
    const surfaceList = surfaceMap[surfaceChoice];

    return _.contains(surfaceList, key);
  }, [surfaceChoice, surfaceMap]);

  useEffect(() => {
    onPlacementFilterChange(placementFilterByPreviewControlState);
  }, [onPlacementFilterChange, placementFilterByPreviewControlState]);

  useEffect(() => {
    onSurfaceChange(surfaceChoice);
  }, [onSurfaceChange, surfaceChoice]);

  return (
    <div className="ad-preview-controls-container">
      <Pivot onLinkClick={item => setSurfaceChoice(item.props.itemKey)}>
        <PivotItem
          itemKey="Msn"
          headerText={showAdPreviewControlsV2 ? 'MSN' : 'msn.com'}
        />
        <PivotItem
          itemKey="Bing"
          headerText="Bing Search"
        />
        {
          !showAdPreviewControlsV2 && (
            <PivotItem
              itemKey="Edge"
              headerText="Edge"
            />
          )
        }
        <PivotItem
          itemKey="Outlook"
          headerText="Outlook"
        />
        {
          permissions && permissions.dynamic.PMaxVideo && (
            <PivotItem
              itemKey="VideoGaming"
              headerText="Video Gaming"
            />
          )
        }
      </Pivot>
    </div>);
};

PerfMaxAdPreviewControls.propTypes = {
  onSurfaceChange: PropTypes.func.isRequired,
  onPlacementFilterChange: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      PMaxVideo: PropTypes.bool,
    }),
  }).isRequired,
  showAdPreviewControlsV2: PropTypes.bool,
};

export const CustomAdPreviewControls = (props) => {
  const {
    onSurfaceChange,
    onPlacementFilterChange,
    customSurfaceKeys,
    i18n,
  } = props;

  const [surfaceChoice, setSurfaceChoice] = useState(_.keys(customSurfaceKeys)[0]);

  const placementFilterByPreviewControlState = useCallback((placement) => {
    const { key } = placement;
    const surfaceMap = _.keys(customSurfaceKeys);

    const surfaceList = surfaceMap[surfaceChoice];

    return _.contains(surfaceList, key);
  }, [surfaceChoice, customSurfaceKeys]);

  useEffect(() => {
    onPlacementFilterChange(placementFilterByPreviewControlState);
  }, [onPlacementFilterChange, placementFilterByPreviewControlState]);

  useEffect(() => {
    onSurfaceChange(surfaceChoice);
  }, [onSurfaceChange, surfaceChoice]);

  return (
    <div className="ad-preview-controls-container">
      <TabList
        size="small"
        onTabSelect={(e, item) => setSurfaceChoice(item.value)}
        defaultSelectedValue={_.keys(customSurfaceKeys)[0]}
      >
        {
          Object.keys(customSurfaceKeys).map(key => (
            <Tab
              key={key}
              itemKey={key}
              value={key}
            >
              {i18n.getString(customSurfaceKeys[key].title)}
            </Tab>
          ))
        }
      </TabList>
    </div>
  );
};
